import { PriceAndCurrencyField } from 'form';
import { useTranslation } from 'i18n';
import { Grid, Typography } from 'ui';

export const RevenuesSection = () => {
  const { t } = useTranslation('orders');

  return (
    <>
      <Typography variant="h5">{t('profitabilityCalculator.revenues.title')}</Typography>
      <Grid container spacing={4}>
        <Grid
          size={{
            md: 3,
            xs: 12,
          }}
        >
          <PriceAndCurrencyField
            slotProps={{
              currency: {
                name: 'buyer_currency',
              },
              price: {
                label: t('profitabilityCalculator.revenues.labels.purchaserPricePerTonne'),
                name: 'buyer_price_per_tonne',
                required: true,
              },
            }}
          />
        </Grid>
        <Grid
          size={{
            md: 3,
            xs: 12,
          }}
        >
          <PriceAndCurrencyField
            slotProps={{
              currency: {
                name: 'pern_currency',
              },
              price: {
                label: t('profitabilityCalculator.revenues.labels.pernRevenuePerTonne'),
                name: 'pern_revenue_per_tonne',
              },
            }}
          />
        </Grid>
      </Grid>
    </>
  );
};
